// @flow
import * as React from 'react';

import { selectCartCurrency } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Badge } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { ListRow } from '../../../../ListRow';

type Props = {
  label: string,
  price: ?number | string,
};

export function DiscountRow({ label, price }: Props): React.MixedElement {
  const { __, formatPrice } = useTranslator();
  const currency = useAppSelector(selectCartCurrency);

  const badge = <Badge intent="promotional">{__('Discount')}</Badge>;
  const negativePrice =
    typeof price === 'number' && price > 0 ? -1 * price : price;

  return (
    <ListRow
      intent="promotional"
      badge={badge}
      price={formatPrice(Number(negativePrice) || 0, currency)}
    >
      {label}
    </ListRow>
  );
}
